module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_305592.c5a92f03.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetAlTFF/FormatoSimplificado_305592.pdf
// module id = 328
// module chunks = 0